<template>
  <div>
    <h2 class="text-left alert" :class="[ removed ? 'alert-danger' : 'alert-success' ]">
      Detection and Treatment of Clinical Cases
      <a class="btn btn-sm" @click="$emit('onRemoveSection', stepName)">
        <span class="glyphicon" :class="[ removed ? 'glyphicon-plus' : 'glyphicon-remove' ]"></span>
      </a>
    </h2>

    <template v-if="!removed">
      <div class="text-left step-section">
        <div v-for="farm in model.FARMS" :key="farm.id">
          <h3 class="text-left" :class="isRemovedSubsection(`farm_${farm.id}-detection_and_treatment`) ? 'comment-disabled' : ''">
            {{ farm.farm_label }}
            <a class="btn btn-sm" @click="$emit('onRemoveSection', stepName, `farm_${farm.id}-detection_and_treatment`)">
              <span class="glyphicon" :class="isRemovedSubsection(`farm_${farm.id}-detection_and_treatment`) ? 'glyphicon-plus' : 'glyphicon-remove'"></span>
            </a>
          </h3>

          <dl class="dl-horizontal">
            <dt>Whole herd regularly stripped for clinical cases?</dt>
            <dd>{{ model[`farm_${farm.id}-is_herd_stripped_clinical_cases`] || '-' }}</dd>
          </dl>

          <dl class="dl-horizontal">
            <dt>Mastitis cows managed in a penicillin mob?</dt>
            <dd>{{ model[`farm_${farm.id}-mastitis_cows_in_penicillin_mob`] || '-' }}</dd>
          </dl>

          <dl class="dl-horizontal">
            <dt>If YES, milking frequency?</dt>
            <dd>{{ model[`farm_${farm.id}-mastitis_mob_milk_freq`] || '-' }}</dd>
          </dl>

          <dl class="dl-horizontal">
            <dt>Teat wipes used when inserting intramammaries?</dt>
            <dd>{{ model[`farm_${farm.id}-are_teat_wipes_used`] || '-' }}</dd>
          </dl>

          <dl class="dl-horizontal">
            <dt>Number of inhibitory substance grades</dt>
            <dd>{{ model[`farm_${farm.id}-num_inhibitory_substance_grades`] || '-' }}</dd>
          </dl>

          <dl class="dl-horizontal">
            <dt>Number of near misses</dt>
            <dd>{{ model[`farm_${farm.id}-num_near_misses`] || '-' }}</dd>
          </dl>

          <dl class="dl-horizontal">
            <dt>Comments</dt>
            <dd>{{ model.COMMENTS.current[`farm_${farm.id}-detection_and_treatment_of_clinical_cases`] || '-' }}</dd>
          </dl>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import mixin from './mixin'

export default {
  mixins: [ mixin ],
  props: ['model'],
  data() {
    return {
      stepName: 'DetectionAndTreatmentOfClinicalCases',
    }
  },
};
</script>
